import { Component, Input } from '@angular/core';
import { MatterAdjustmentSalePrice, NetOutHstOptions } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';
import { calculateSale } from 'src/app/shared/services/adjustments';

@UntilDestroy()
@Component({
	selector: 'app-sale-price-breakdown',
	templateUrl: './sale-price-breakdown.component.html',
	standalone: false,
})
export class SalePriceBreakdownComponent {
	creditAmount = 0;
	hstFed = 0;
	hstProv = 0;
	hstRebateFed = 0;
	hstRebateProv = 0;
	nsp = 0;
	nspReal = 0;
	total = 0;

	_adjustment: MatterAdjustmentSalePrice;

	_purchasePrice: number;

	public netOutHstOptions = NetOutHstOptions;

	@Input() set purchasePrice(price: number) {
		this._purchasePrice = price;
		this.calculateSaleValues();
	}

	get purchasePrice() {
		return this._purchasePrice;
	}

	@Input() set adjustment(salePriceAdjustment: MatterAdjustmentSalePrice) {
		this._adjustment = salePriceAdjustment;
		this.calculateSaleValues();
	}

	get adjustment() {
		return this._adjustment;
	}

	calculateSaleValues(): void {
		[
			this.creditAmount,
			this.total,
			this.hstFed,
			this.hstProv,
			this.hstRebateFed,
			this.hstRebateProv,
			this.nsp,
			this.nspReal,
		] = calculateSale(
			`${this.purchasePrice}`,
			`${this.adjustment?.considerations}`,
			`${this.adjustment?.credits}`,
			`${this.adjustment?.chattels}`,
			this.adjustment?.netOutHst,
			this.adjustment?.creditVendor,
			this.adjustment?.gst,
			this.adjustment?.pst,
		);
	}
}
